export default {"src":"/_next/static/media/mood-meter-chart-background.801adbe5.svg","height":700,"width":700};